import { render, staticRenderFns } from "./ProblemReport.vue?vue&type=template&id=7836cb34&scoped=true&"
import script from "./ProblemReport.vue?vue&type=script&lang=js&"
export * from "./ProblemReport.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./ProblemReport.vue?vue&type=style&index=1&id=7836cb34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7836cb34",
  null
  
)

export default component.exports